// src/components/Common/Filter.tsx
import React from "react";
import { Box, TextField, MenuItem } from "@mui/material";

interface FilterOption {
  value: string;
  label: string;
}

interface FilterProps {
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  filterOptions?: FilterOption[];
  selectedFilter?: string;
  onFilterChange?: (value: string) => void;
  loading?: boolean;
  
}

const Filter: React.FC<FilterProps> = ({
  searchPlaceholder = "Search...",
  searchValue,
  onSearchChange,
  filterOptions,
  selectedFilter,
  onFilterChange,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Search Input */}
      <TextField
        label={searchPlaceholder}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        fullWidth
      />
      
      {/* Dropdown Filter */}
      {filterOptions && (
        <TextField
          label="Filter By"
          select
          value={selectedFilter || ""}
          onChange={(e) => onFilterChange?.(e.target.value)}
          fullWidth
        >
          <MenuItem value="">All</MenuItem>
          {filterOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Box>
  );
};

export default Filter;
